import Vue from 'vue';

import { mountVue } from './utils/vueContainer';

// Register components
import Modal from '../../components/modal/Modal';
import Gallery from '../../components/gallery/Gallery';
import PreviewGrid from '../../components/previewGrid/PreviewGrid';
import NewsGrid from '../../components/newsGrid/NewsGrid';
import Bleed from '../../components/bleed/Bleed';

// ------------------------------------------------------------------------
// Boot App
// ------------------------------------------------------------------------
require('./boot');

// ------------------------------------------------------------------------
// Register Vue Components
// ------------------------------------------------------------------------
Vue.component('modal', Modal);
Vue.component('gallery', Gallery);
Vue.component('previewGrid', PreviewGrid);
Vue.component('newsGrid', NewsGrid);
Vue.component('bleed', Bleed);

// ------------------------------------------------------------------------
// Mount Vue Instances (outside of Barba container)
// ------------------------------------------------------------------------
mountVue('.js-vueContainer', document);

// ------------------------------------------------------------------------
// Triggers once the app has been launched
// ------------------------------------------------------------------------
document.addEventListener('AppReady', () => {
    document.documentElement.classList.remove('no-fouc');
});

// ------------------------------------------------------------------------
// Launch the app
// ------------------------------------------------------------------------
if (document.readyState === 'complete') {
    document.dispatchEvent(new CustomEvent('AppReady'));
} else {
    document.addEventListener('DOMContentLoaded', () => document.dispatchEvent(new CustomEvent('AppReady')));
}
